import { replace } from 'react-router-redux';

import _omit from 'lodash/omit';
import _pathOr from 'lodash/fp/pathOr';
import _mapValues from 'lodash/mapValues';

import http from '../../../../../shared/http';
import endpoints from '../../../../../../config/endpoints';
import { actions as parentActions } from '../../../editor';
import {
	createSelectOptionsFromSysEnums,
	createSelectValuesUseIntersection
} from '../../../../../shared/form-elements/select';

const defaultInitialState = {
	currentLanguage: 'en',
	fileToUpload: null,
	fields: {
		title: '',
		leads_required: '',
		offer_category: '',
		country: '',
		start_period: '',
		translations: {
			ru: {
				title: ''
			},
			de: {
				title: ''
			},
			vi: {
				title: ''
			},
			th: {
				title: ''
			}
		}
	}
};

const startPeriodsEnum = ['day', 'week', 'month', 'quarter', 'year'].map(p => ({ id: p, title: p }));

const errorReducerFn = (state, action) => {
	if (action.payload.response.status !== 400) {
		return ({ ...state, error: true, showProgressBar: false });
	}
	return state;
};

const createGeneralForm = ({
	namespace, stateNodeName
}) => {

	const MAIN_FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-success`;
	const MAIN_FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-error`;

	const MAIN_FORM_UPLOAD_SUCCESS = `${namespace}/${stateNodeName}-upload-success`;
	const MAIN_FORM_UPLOAD_ERROR = `${namespace}/${stateNodeName}-upload-error`;
	const MAIN_FORM_PREPARATION_FILE = `${namespace}/${stateNodeName}-preparation-file-success`;
	const MAIN_FORM_CHANGE_LANGUAGE = `${namespace}/${stateNodeName}-change-language`;

	const initialState = {
		...defaultInitialState
	};

	const actions = {
		mainFormSubmit: formData => (dispatch, getState) => {
			const { data } = getState().achievementsEditor;
			const submitData = _mapValues(formData, val => _pathOr(val, ['0', 'value'], val));
			const url = data.id ? `${endpoints.ACHIEVEMENTS.BASE}/${data.id}` : endpoints.ACHIEVEMENTS.BASE;

			submitData.country_ids = formData.countries ? formData.countries.map(ct => ct.value) : null;

			const request = http({
				url: url,
				method: data.id ? 'put': 'post',
				data: _mapValues(
					_omit(submitData, ['image_active']), val => Array.isArray(val) && !val[0]?  null : val
				),
				actions: [ MAIN_FORM_SUBMIT_SUCCESS, MAIN_FORM_SUBMIT_ERROR ]
			});

			return request(dispatch).then(() => {
				const { fileToUpload } = getState().achievementsEditor.mainForm;
				if (fileToUpload) {
					return actions.uploadFile(data.id, fileToUpload, dispatch);
				}
			}).then(() => {
				setTimeout(() => { dispatch(replace('/achievements')); }, 300);
			});
		},

		mainFormChangeLanguage: lang => dispatch => {
			return dispatch({ type: MAIN_FORM_CHANGE_LANGUAGE, payload: lang });
		},

		preparationFile: (file, nextAction) => dispatch => {
			const reader = new FileReader();
			const data = new FormData();

			data.append('image', file);

			reader.readAsDataURL(file);
			reader.onloadend = function () {
				nextAction(reader.result);
				dispatch({
					type: MAIN_FORM_PREPARATION_FILE,
					payload: data
				});
			};
		},

		uploadFile: (missionId, fileToUpload, dispatch) => {
			const request = http({
				url: endpoints.ACHIEVEMENTS.UPLOAD_ACHIEVEMENTS_IMAGE.replace('{id}', missionId),
				method: 'put',
				actions: [MAIN_FORM_UPLOAD_SUCCESS, MAIN_FORM_UPLOAD_ERROR],
				data: fileToUpload
			});

			dispatch(parentActions.toggleProgressBar());

			request(dispatch)
				.then(action => {
					if (action.type === MAIN_FORM_UPLOAD_SUCCESS) {
						dispatch(parentActions.toggleProgressBar());
						dispatch(parentActions.fetchData(missionId));
					}
				});
		}

	};

	const reducers = {
		[MAIN_FORM_SUBMIT_ERROR]: errorReducerFn,
		[MAIN_FORM_UPLOAD_ERROR]: errorReducerFn,
		[MAIN_FORM_PREPARATION_FILE]: (state, action) => ({
			...state,
			mainForm: {
				...state.mainForm,
				fileToUpload: action.payload
			}
		}),
		[MAIN_FORM_CHANGE_LANGUAGE]: (state, action) => ({
			...state,
			mainForm: {
				...state.mainForm,
				currentLanguage: action.payload
			}
		})
	};

	const selectors = {
		getCurrentLanguage: _pathOr('en', ['achievementsEditor', 'mainForm', 'currentLanguage']),
		getOfferCategoriesOptions: state => createSelectOptionsFromSysEnums(state.root.lists['offer-categories']),
		getStartPeriodOptions: () => createSelectOptionsFromSysEnums(startPeriodsEnum),
		getMainFormData: state => {
			const { data: achievement } = state.achievementsEditor;
			const category = _pathOr('', 'offer_category', achievement);
			const startPeriod = _pathOr('', 'start_period', achievement);
			const offerCategories = createSelectOptionsFromSysEnums(state.root.lists['offer-categories']);
			const startPeriods = createSelectOptionsFromSysEnums(startPeriodsEnum);
			const countries = createSelectOptionsFromSysEnums(achievement && achievement.countries);
			return {
				initialValues: {
					...state.achievementsEditor.data,
					countries: countries,
					offer_category: createSelectValuesUseIntersection(offerCategories, [category]),
					start_period: createSelectValuesUseIntersection(startPeriods, [startPeriod])
				}
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createGeneralForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/missions/achievement/components/forms/general/index.js